import { render } from "./Inspiracion.vue?vue&type=template&id=1ac14b17&scoped=true"
import script from "./Inspiracion.vue?vue&type=script&lang=js"
export * from "./Inspiracion.vue?vue&type=script&lang=js"

import "./Inspiracion.vue?vue&type=style&index=0&id=1ac14b17&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac14b17"]])

export default __exports__